export default __webpack_public_path__ + "static/broadcastImg1-a98d772b5f720e8a0e27fcf2ae6b94bf.webp";